import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-bottom-doodle.svg';
import CategoryFacetItem from '~/components/molecules/Category/CategoryFacetItem.vue';
export default {
  name: 'CategoryCheckboxFilter',
  components: {
    CategoryFacetItem: CategoryFacetItem
  },
  props: {
    selected: {
      type: Array,
      required: true
    },
    filter: {
      type: Object,
      required: true
    },
    desktopLayer: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      active: false,
      showAll: false,
      maxItems: 6,
      checkedFacets: []
    };
  },
  computed: {
    facets: function facets() {
      var facets = this.filter.facets.filter(function (e) {
        return e.label;
      });
      return this.showAll || this.isColor ? facets : facets.slice(0, 16);
    },
    isColor: function isColor() {
      return ['color', 'segmentations.colors.label'].includes(this.filter.name);
    },
    checkboxClasses: function checkboxClasses() {
      return {
        'justify-content-lg-center': !this.isColor && this.facets.length <= 4 && !this.desktopLayer,
        'justify-content-lg-start m-auto': this.isColor || this.facets.length > 4 || this.desktopLayer,
        'flex-md-row': !this.desktopLayer
      };
    }
  },
  watch: {
    filter: function filter() {
      this.scrollToTop();
      this.showAll = false;
      this.checkedFacets = this.facets ? this.facets.filter(function (f) {
        return f.selected;
      }).map(function (f) {
        return f.key;
      }) : [];
    }
  },
  mounted: function mounted() {
    this.checkedFacets = this.facets ? this.facets.filter(function (f) {
      return f.selected;
    }).map(function (f) {
      return f.key;
    }) : [];
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    filterBy: 'pageActions/FILTER_BY'
  })), {}, {
    selectedFacet: function selectedFacet(facet) {
      return this.selected.map(function (e) {
        return e.facet;
      }).includes(facet);
    },
    tracking: function tracking(facet) {
      var filter = "".concat(this.filter.label.charAt(0).toUpperCase()).concat(this.filter.label.slice(1));
      return {
        data: {
          event_category: window.tc_vars.env_template === 'listproduct_keyword' ? 'Search Page' : 'Categorie',
          event_action: "Filtre_".concat(filter, "_").concat(facet.label),
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    },
    scrollToTop: function scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    applyCheckboxChanges: function applyCheckboxChanges(facet, evt) {
      this.filterBy({
        filter: this.filter.name,
        facet: facet.key
      });
      this.$root.$emit('generic-tracking', evt, this.tracking(facet));
      if (!this.checkedFacets.includes(facet.key)) this.checkedFacets.push(facet.key);else this.checkedFacets = this.checkedFacets.filter(function (e) {
        return e !== facet.key;
      });
    },
    seeMore: function seeMore() {
      this.showAll = true;
    }
  })
};